import PatientCard from "../../components/PaitientCard/PatientCard";
import { Link } from "react-router-dom";
import "./AppointmentsPatient.scss";
import { DoctorconsoleGrid } from "../doctor-console/StyledComponents";

function AppointmentsPatient() {
  return (
    <>
      <DoctorconsoleGrid>
        <div className="content-left">
          <h3 className="title">Appointments</h3>
          <div className="tab-container">
            <div className="tab-left">
              <div className="tab-active">
                <span>Day</span>
              </div>
              <div className="tab">
                <span> Week </span>
              </div>
              <div className="tab">
                <span> Month </span>
              </div>
            </div>
            <div className="tab-right">
              <span className="tab-date"> 7th April </span>
              <div className="tab-pagination-buttons">
                <button className="pagination-button">
                  <img
                    src="/img/left-arrow-blue.svg"
                    alt="previous-page"
                    width="16"
                    height="16"
                  />
                </button>
                <button className="pagination-button">
                  <img
                    src="/img/Expand - icon-5.svg"
                    alt="previous-page"
                    width="16"
                    height="16"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="patient-status-container">
            <svg width="15" height="15" viewBox="0 0 15 15">
              <rect width="15" height="15" style={{ fill: "#fbc42f" }} />
            </svg>
            <span className="patient-status">
              &nbsp; New Patient &nbsp; &nbsp;
            </span>
            <svg width="15" height="15" viewBox="0 0 15 15">
              <rect width="15" height="15" style={{ fill: "#056105" }} />
            </svg>
            <span className="patient-status">&nbsp; Existing Patient</span>
          </div>
          <div className="patient-list">
            <div className="patient-info-yellow">
              <span className="patient-time-gray-size">
                10:00 am - 10:30 am
              </span>
              <img
                src="/img/Path 49380.svg"
                alt="Patient Photo"
                height="40"
                width="40"
              />
              <span className="patient-name">Dr Ashish N...</span>
              <span className="patient-name">General physician</span>
              <button className="complete-button" disabled>
                <img
                  src="/img/success-green-check-mark.svg"
                  alt="Complete Icon"
                />
                &nbsp; Complete
              </button>
              <div className="info-button">
                <img src="/img/3-vertical-dots.svg" alt="info dots" />
              </div>
            </div>
            <div className="patient-info-green">
              <span className="patient-time-gray-size">
                01:00 pm - 01:30 pm
              </span>
              <img
                src="/img/Path 49380.svg"
                alt="Patient Photo"
                height="40"
                width="40"
              />
              <span className="patient-name">Dr Jiya Mehra</span>
              <span className="patient-name">gynecologist</span>
              <Link
                to={{ pathname: "/patient/tele-console-patient" }}
                className="blue-button"
              >
                <img src="/img/red-play-button.svg" alt="Complete Icon" />
                &nbsp; Start
              </Link>
              <div className="info-button">
                <img src="/img/3-vertical-dots.svg" alt="info dots" />
              </div>
            </div>
          </div>
        </div>
        <PatientCard />
      </DoctorconsoleGrid>
    </>
  );
}
export default AppointmentsPatient;
